import * as React from 'react';

export type Props = {
  children?: React.ReactNode;
  empty?: boolean;
};

export default function TableCell({ children, empty }: Props) {
  return <td className="TableCell">{empty ? '—' : children}</td>;
}
